import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Navigate, Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import i18next, { SupportedLanguages } from "./locales/i18n";
import About from "./pages/About";
import Error from "./pages/Error";
import MotoShowcase from "./pages/MotoShowcase";
import MotoDetails from "./pages/MotoDetails";
import Partners from "./pages/Partners";
import RouteWrapper from "./components/route-wrapper/RouteWrapper";
import { getMotorcycles } from "./api/moto.api";

const { t, language: lang } = i18next;
const router = createBrowserRouter([
  {
    path: `/`,
    element: <App />,
    loader: async ({ }) => getMotorcycles(lang as SupportedLanguages),
    children: [
      {
        path: lang,
        // errorElement: <Error />,
        children: [
          {
            path: t('routes:home'),
            element: (
              <RouteWrapper title={t('common:title.home')}>
                <Home />
              </RouteWrapper>
            )
          },
          {
            path: t('routes:about-us'),
            element: (
              <RouteWrapper title={t('common:title.about-us')}>
                <About />
              </RouteWrapper>
            )
          },
          {
            path: t('routes:rent-moto'),
            element: (
              <RouteWrapper title={t('common:title.motorcycles')}>
                <Outlet />
              </RouteWrapper>
            ),
            children: [
              {
                index: true,
                element: <MotoShowcase />,
              },
              {
                path: ':motoName',
                element: <MotoDetails />
              }
            ]
          },
          {
            path: t('routes:partners'),
            element: (
              <RouteWrapper title={t('common:title.partners')}>
                <Partners />
              </RouteWrapper>
            )
          },
          {
            path: t('routes:contact'),
            element: (
              <RouteWrapper title={t('common:title.contact')}>
                <Contact />
              </RouteWrapper>
            )
          },
          {
            path: t('routes:error'),
            element: (
              <RouteWrapper title={t('common:title.error')}>
                <Error />
              </RouteWrapper>
            )
          },
          {
            index: true,
            element: <Navigate to={`${t('routes:home')}`} />
          }
        ]
      },
      {
        index: true,
        element: <Navigate to={`${lang}/${t('routes:home')}`} />
      }
    ],
  },
  {
    path: '*',
    element: <Navigate to={`/`} />
  }
]);

const rootElement = document.getElementById("root") as HTMLElement;

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement,
    <React.StrictMode>
      <React.Suspense fallback="loading">
        <RouterProvider router={router} />
      </React.Suspense>
    </React.StrictMode>
  );
} else {
  ReactDOM
    .createRoot(rootElement)
    .render(
      <React.StrictMode>
        <React.Suspense fallback="loading">
          <RouterProvider router={router} />
        </React.Suspense>
      </React.StrictMode>
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
